import React, { useEffect, useState } from 'react'
import SAModal from '../../../Common/Custom Components/Ant design/SAModal'
import { Select, Spin, Table } from 'antd';
import DashboardService, { DashboardStateType } from '../../../Services/DashboardService';
import { LoadingOutlined } from '@ant-design/icons';
import { Utils } from '../../../Utilities/Utils';
import { ColumnsType } from 'antd/es/table';
import type { AlignType } from 'rc-table/lib/interface';
import { IPractices } from '../../../Context/PracticeContext';

interface IProps {
    modelType: DashboardStateType,
    open: boolean,
    onCancel: () => void,
    fromDate: string,
    toDate: string,
    filteredPracticeIds: IPractices[],
    modelTitle: string,
    tableTitle: string,
    align: AlignType,
}

interface ColDateType {
    sno: number;
    tenantsId: number;
    practice: string;
    totalNumbers: number;
}

const DashBoardStatsModel = ({ modelType, open, onCancel, fromDate, toDate, filteredPracticeIds, modelTitle, tableTitle, align }: IProps) => {
    const [loading, setLoading] = useState(false);
    const [invoiceStatsData, setInvoiceStatsData] = useState([]);
    const [listParams, setListParams] = React.useState({
        totalRecords: 0,
        currentPage: 1,
        pageSize: 15,
        sortCol: "_id",
        sortDir: "ascend",
        selectPId: []
    });

    const getInvoiceStatsDetails = async () => {
        try {
            setLoading(true)
            const res = await DashboardService.getModelStateDetails(modelType, (listParams.currentPage - 1) * listParams.pageSize, listParams.pageSize, fromDate, toDate, listParams.sortDir, listParams.sortCol, listParams.selectPId)
            if (res?.result && res?.status && res?.result?.items) {
                setInvoiceStatsData(res?.result?.items)
                setListParams({
                    ...listParams,
                    totalRecords: res?.result?.totalRecords,
                })
            }
        } catch (error) {
            console.error(error)
        }
        finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        getInvoiceStatsDetails()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [listParams.currentPage, listParams.pageSize, listParams.sortCol, listParams.sortDir, listParams.selectPId])

    const columns: ColumnsType<ColDateType> = [
        {
            title: "S.No",
            dataIndex: "sno",
            key: "sno",
            width: "10%",
        },
        {
            title: "Tenant",
            dataIndex: "tenantsId",
            key: "_id",
            width: "20%",
            sorter: true,
            defaultSortOrder: "ascend",
            showSorterTooltip: false,
            render: (_: any, record: any, index: any) => (
                <p>{`Tenant ${record.tenantsId}`}</p>
            ),
        },
        {
            title: "Practice",
            dataIndex: "practice",
            key: "Practice",
            sorter: true,
            showSorterTooltip: false,
        },
        {
            title: tableTitle,
            dataIndex: "totalNumbers",
            key: "TotalNumbers",
            align: align,
            width: "20%",
            sorter: true,
            showSorterTooltip: false,
            render: (_: any, record: any, index: any) => (
                align === "end" ?
                    <p>{`£${Utils.getFormattedNumber(record?.totalNumbers)}`}</p>
                    :
                    <p>{record?.totalNumbers}</p>
            )
            ,
        },

    ];

    return (
        <SAModal width={800} title={modelTitle} open={open} onCancel={onCancel} footer={false}>
            <div style={{ display: "flex", justifyContent: "flex-end" }} className="pb-2">
                <Select
                    onChange={(e) => setListParams({
                        ...listParams,
                        selectPId: e,
                    })}
                    mode="multiple"
                    maxTagCount="responsive"
                    style={{ width: 280 }}
                    placeholder="Select Practice"
                    showSearch
                    filterOption={(input: any, option: any) =>
                        option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                    options={filteredPracticeIds.map((p: IPractices) => ({
                        value: p.value,
                        label: p.label + " (ID: " + p.value + ")",
                    }))}
                />
            </div>
            <Table
                columns={columns}
                size='small'
                dataSource={invoiceStatsData}
                onChange={(paging, filter, sort: any) => {
                    if (
                        paging?.current !== undefined &&
                        paging?.pageSize !== undefined
                    ) {
                        setLoading(true);
                        setListParams({
                            ...listParams,
                            sortDir: sort.order !== undefined ? sort.order : "ascend",
                            sortCol:
                                sort.order !== undefined
                                    ? sort.columnKey
                                    : "_id",
                            currentPage:
                                paging.current !== undefined ? paging.current : 1,
                            pageSize:
                                paging.pageSize !== undefined ? paging.pageSize : 15,
                        });
                    }
                }}
                // className="border-top-table"
                pagination={{
                    showTotal: (total, range) =>
                        `${range[0]}-${range[1]} of ${total} items`,
                    current: listParams.currentPage,
                    pageSize: listParams.pageSize,
                    showSizeChanger: true,
                    total: listParams.totalRecords,
                    pageSizeOptions: ["15", "25", "50", "100"],
                }}
                loading={{
                    spinning: loading,
                    size: "small",
                    indicator: (
                        <Spin
                            indicator={<LoadingOutlined style={{ fontSize: 20 }} spin />}
                        />
                    ),
                }} />
        </SAModal>
    )
}

export default DashBoardStatsModel;